<div class="table-dropdown" *ngIf="dropDownOption.length">
  <button class="btn-select-dropdown" [matMenuTriggerFor]="checkboxMenu" #menuTrigger="matMenuTrigger">
    <span> {{ selectedOptions?.length == 1 ? (selectedOptions[0] | langtranslate ) : (selectedOptions[0] | langtranslate) + ' (+' + (selectedOptions.length - 1) +')' }}</span>
    <mat-icon>keyboard_arrow_down</mat-icon>
  </button>
  <mat-menu #checkboxMenu="matMenu" [xPosition]="langName === 'ar' ? 'after' : 'before'"
    class="grades-menu-selection residential-menu" (closed)="onMenuClosed()">
    <div (click)="$event.stopPropagation()">
      <h5 class="menu-label" *ngIf="!search">
     {{ (dropdownTitle | translate) }}
      </h5>
       <mat-checkbox (change)="selectAll($event)"
          [checked]="isCheckedSelectAll()">
          {{ 'reports.un_select_all' | translate}}
        </mat-checkbox>

      <ng-container *ngFor="let data of filteredOptions">
        <mat-checkbox (change)="toggleResidentialType($event, data.name)"
        [checked]="selectedItem.includes(data.name)">
          {{ data.label | langtranslate}}
        </mat-checkbox>
      </ng-container>
      <div class="no-result-found" *ngIf="filteredOptions?.length == 0">{{'reports.no-result-found'|translate}}</div>
    </div>
  </mat-menu>

</div>